import {
    AcceptUserAgreementsInput,
    AccountBalanceSummary,
    Agreement,
    Agreements,
    AllSubscriptions,
    AllowedFeature,
    AlternateLanguage,
    Artist,
    Balance,
    Brandtype,
    Classifier,
    Collection,
    ContentGroup,
    ContentList,
    CostPreviewResponse,
    CreatorSession,
    CreatorSessionInput,
    CreditBalancePayloadType,
    Currency,
    CurrentSubscription,
    CurrentSubscriptionDetails,
    Descriptor,
    Filter,
    FilterCategories,
    FilterFamily,
    FilterMeta,
    FilterWithLabel,
    Filters,
    Genre,
    GenreInput,
    GrantedCredits,
    HeroBanner,
    Instrument,
    InstrumentInput,
    Key,
    KeyInput,
    Label,
    LabelsChart,
    LabelsChartItem,
    MerchZone,
    MetaPage,
    Mutation,
    NextPage,
    OverduePayment,
    Pack,
    PackFavoritedInput,
    PackagesMeta,
    PacksChart,
    PacksChartItem,
    PaginatedArtists,
    PaginatedLabels,
    PaginatedPacks,
    PaginatedPacksOrRepacks,
    PaginatedRepacks,
    PaginatedSamples,
    PaginatedUserCollections,
    PlanFrequencyIdentifier,
    PlanIncludedFeatures,
    PluginPackages,
    Price,
    PrismicBackgroundImage,
    PrismicBanner,
    PrismicDocument,
    PrismicImage,
    PrismicImageDimensions,
    PrismicSampleAuthBannerCtaLink,
    PrismicSampleAuthBannerCtaText,
    PrismicSampleAuthBannerData,
    PrismicSampleAuthBannerDescription,
    PrismicSampleAuthBannerTitle,
    PrismicSampleBannerData,
    PrismicSampleBannerGroupData,
    PrismicTextField,
    PurchasableCreatorSample,
    PurchasableCreatorSession,
    PurchaseResponse,
    Query,
    Repack,
    RepackFavoritedInput,
    RepacksChart,
    RepacksChartItem,
    Sample,
    SampleFavoritedInput,
    SampleKey,
    SampleKeyInput,
    SampleTypeFilter,
    SamplesIncludedFeature,
    Seo,
    SeoMetadata,
    SeoMetadataInput,
    Sfx,
    StreamUrl,
    SubItems,
    SubscriptionCreditsDetails,
    SubscriptionDetails,
    SubscriptionPlanProductDetails,
    SubscriptionsAndAllowedFeatures,
    Tag,
    TagCategoryFilter,
    TagsCategory,
    Track,
    TrackInput,
    UnallowedReason,
    User,
    UserCollection,
    UserCollectionsFeed,
    UserCredits,
    UserRecentSearch,
    UserRecentSearches,
    Waveform,
    AccountStatusEnum,
    BpmMultiplier,
    ClassifierType,
    ContentTarget,
    HeroBannerContentType,
    HomePageEnum,
    Interval,
    KeyQuality,
    KeyRootApi,
    KeySign,
    LegalAgreementKindEnum,
    Locale,
    MusicGenre,
    OccupationEnum,
    PackState,
    PackType,
    PremiumCodes,
    ProviderType,
    RepackSubType,
    SampleState,
    SampleType,
    ServiceOfferKind,
    ServiceStatusEnum,
    SubscriptionBillingCommitment,
    SubscriptionDetailsStatus,
    SubscriptionFrequency,
    SubscriptionProductStatus,
    SubscriptionStatusEnum,
    UserSearchFilter,
} from '../../types/generated/graphql';

export const anAcceptUserAgreementsInput = (
    overrides?: Partial<AcceptUserAgreementsInput>,
): AcceptUserAgreementsInput => {
    return {
        kinds:
            overrides && overrides.hasOwnProperty('kinds')
                ? overrides.kinds!
                : [LegalAgreementKindEnum.PrivacyPolicy],
    };
};

export const anAccountBalanceSummary = (
    overrides?: Partial<AccountBalanceSummary>,
): { __typename: 'AccountBalanceSummary' } & AccountBalanceSummary => {
    return {
        __typename: 'AccountBalanceSummary',
        accountingStatus:
            overrides && overrides.hasOwnProperty('accountingStatus')
                ? overrides.accountingStatus!
                : AccountStatusEnum.Collection,
        balance:
            overrides && overrides.hasOwnProperty('balance')
                ? overrides.balance!
                : 8.1,
        currencyCode:
            overrides && overrides.hasOwnProperty('currencyCode')
                ? overrides.currencyCode!
                : 'tollo',
        currencySymbol:
            overrides && overrides.hasOwnProperty('currencySymbol')
                ? overrides.currencySymbol!
                : 'acerbitas',
        overduePayments:
            overrides && overrides.hasOwnProperty('overduePayments')
                ? overrides.overduePayments!
                : [anOverduePayment()],
    };
};

export const anAgreement = (
    overrides?: Partial<Agreement>,
): { __typename: 'Agreement' } & Agreement => {
    return {
        __typename: 'Agreement',
        kind:
            overrides && overrides.hasOwnProperty('kind')
                ? overrides.kind!
                : LegalAgreementKindEnum.PrivacyPolicy,
        requireUpdate:
            overrides && overrides.hasOwnProperty('requireUpdate')
                ? overrides.requireUpdate!
                : true,
        version:
            overrides && overrides.hasOwnProperty('version')
                ? overrides.version!
                : 'arcesso',
    };
};

export const anAgreements = (
    overrides?: Partial<Agreements>,
): { __typename: 'Agreements' } & Agreements => {
    return {
        __typename: 'Agreements',
        agreements:
            overrides && overrides.hasOwnProperty('agreements')
                ? overrides.agreements!
                : [anAgreement()],
    };
};

export const anAllSubscriptions = (
    overrides?: Partial<AllSubscriptions>,
): { __typename: 'AllSubscriptions' } & AllSubscriptions => {
    return {
        __typename: 'AllSubscriptions',
        subscriptions:
            overrides && overrides.hasOwnProperty('subscriptions')
                ? overrides.subscriptions!
                : [aCurrentSubscription()],
    };
};

export const anAllowedFeature = (
    overrides?: Partial<AllowedFeature>,
): { __typename: 'AllowedFeature' } & AllowedFeature => {
    return {
        __typename: 'AllowedFeature',
        isAllowed:
            overrides && overrides.hasOwnProperty('isAllowed')
                ? overrides.isAllowed!
                : true,
        unallowedReason:
            overrides && overrides.hasOwnProperty('unallowedReason')
                ? overrides.unallowedReason!
                : anUnallowedReason(),
    };
};

export const anAlternateLanguage = (
    overrides?: Partial<AlternateLanguage>,
): { __typename: 'AlternateLanguage' } & AlternateLanguage => {
    return {
        __typename: 'AlternateLanguage',
        id:
            overrides && overrides.hasOwnProperty('id')
                ? overrides.id!
                : 'ca3000b3-d5f9-4e64-9bcb-44843f4d3aec',
        lang:
            overrides && overrides.hasOwnProperty('lang')
                ? overrides.lang!
                : 'cicuta',
        type:
            overrides && overrides.hasOwnProperty('type')
                ? overrides.type!
                : 'aedificium',
        uid:
            overrides && overrides.hasOwnProperty('uid')
                ? overrides.uid!
                : 'deleniti',
    };
};

export const anArtist = (
    overrides?: Partial<Artist>,
): { __typename: 'Artist' } & Artist => {
    return {
        __typename: 'Artist',
        artworkUrl:
            overrides && overrides.hasOwnProperty('artworkUrl')
                ? overrides.artworkUrl!
                : 'denuo',
        coverUrl:
            overrides && overrides.hasOwnProperty('coverUrl')
                ? overrides.coverUrl!
                : 'deprimo',
        description:
            overrides && overrides.hasOwnProperty('description')
                ? overrides.description!
                : 'commemoro',
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : '2134d417-7b24-4be0-8ce4-a979ee56ddad',
        isExclusive:
            overrides && overrides.hasOwnProperty('isExclusive')
                ? overrides.isExclusive!
                : true,
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'virga',
        packCount:
            overrides && overrides.hasOwnProperty('packCount')
                ? overrides.packCount!
                : 9687,
        portraitUrl:
            overrides && overrides.hasOwnProperty('portraitUrl')
                ? overrides.portraitUrl!
                : 'confido',
        sampleCount:
            overrides && overrides.hasOwnProperty('sampleCount')
                ? overrides.sampleCount!
                : 9704,
        slug:
            overrides && overrides.hasOwnProperty('slug')
                ? overrides.slug!
                : 'sapiente',
    };
};

export const aBalance = (
    overrides?: Partial<Balance>,
): { __typename: 'Balance' } & Balance => {
    return {
        __typename: 'Balance',
        balance:
            overrides && overrides.hasOwnProperty('balance')
                ? overrides.balance!
                : 8133,
    };
};

export const aBrandtype = (
    overrides?: Partial<Brandtype>,
): { __typename: 'Brandtype' } & Brandtype => {
    return {
        __typename: 'Brandtype',
        description:
            overrides && overrides.hasOwnProperty('description')
                ? overrides.description!
                : 'ustulo',
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : 'd44cd438-084b-46c6-ae05-fd72d66d0c0a',
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'caelum',
        packCount:
            overrides && overrides.hasOwnProperty('packCount')
                ? overrides.packCount!
                : 9746,
        sampleCount:
            overrides && overrides.hasOwnProperty('sampleCount')
                ? overrides.sampleCount!
                : 364,
        slug:
            overrides && overrides.hasOwnProperty('slug')
                ? overrides.slug!
                : 'verbera',
    };
};

export const aClassifier = (
    overrides?: Partial<Classifier>,
): { __typename: 'Classifier' } & Classifier => {
    return {
        __typename: 'Classifier',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'cras',
        id:
            overrides && overrides.hasOwnProperty('id')
                ? overrides.id!
                : '805303cf-872c-4a9a-9f0c-fc0fc4ed5caa',
        isPackClassifier:
            overrides && overrides.hasOwnProperty('isPackClassifier')
                ? overrides.isPackClassifier!
                : true,
        type:
            overrides && overrides.hasOwnProperty('type')
                ? overrides.type!
                : ClassifierType.Free,
    };
};

export const aCollection = (
    overrides?: Partial<Collection>,
): { __typename: 'Collection' } & Collection => {
    return {
        __typename: 'Collection',
        artworkUrl:
            overrides && overrides.hasOwnProperty('artworkUrl')
                ? overrides.artworkUrl!
                : 'uter',
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : '30c1b2d2-5935-452b-9979-d4cb18335676',
        isDownloaded:
            overrides && overrides.hasOwnProperty('isDownloaded')
                ? overrides.isDownloaded!
                : false,
        isExclusive:
            overrides && overrides.hasOwnProperty('isExclusive')
                ? overrides.isExclusive!
                : true,
        isFavorited:
            overrides && overrides.hasOwnProperty('isFavorited')
                ? overrides.isFavorited!
                : true,
        isFree:
            overrides && overrides.hasOwnProperty('isFree')
                ? overrides.isFree!
                : true,
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'toties',
        slug:
            overrides && overrides.hasOwnProperty('slug')
                ? overrides.slug!
                : 'ea',
        subType:
            overrides && overrides.hasOwnProperty('subType')
                ? overrides.subType!
                : RepackSubType.Chart,
        type:
            overrides && overrides.hasOwnProperty('type')
                ? overrides.type!
                : PackType.Pack,
    };
};

export const aContentGroup = (
    overrides?: Partial<ContentGroup>,
): { __typename: 'ContentGroup' } & ContentGroup => {
    return {
        __typename: 'ContentGroup',
        byline:
            overrides && overrides.hasOwnProperty('byline')
                ? overrides.byline!
                : 'torrens',
        contentLists:
            overrides && overrides.hasOwnProperty('contentLists')
                ? overrides.contentLists!
                : [aContentList()],
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : 'fbde777d-cd0a-44da-a4e8-4cde510336ac',
        target:
            overrides && overrides.hasOwnProperty('target')
                ? overrides.target!
                : ContentTarget.AuthenticatedOnly,
        title:
            overrides && overrides.hasOwnProperty('title')
                ? overrides.title!
                : 'ea',
        to:
            overrides && overrides.hasOwnProperty('to')
                ? overrides.to!
                : 'depulso',
    };
};

export const aContentList = (
    overrides?: Partial<ContentList>,
): { __typename: 'ContentList' } & ContentList => {
    return {
        __typename: 'ContentList',
        items:
            overrides && overrides.hasOwnProperty('items')
                ? overrides.items!
                : [aPack()],
        tabName:
            overrides && overrides.hasOwnProperty('tabName')
                ? overrides.tabName!
                : 'conitor',
    };
};

export const aCostPreviewResponse = (
    overrides?: Partial<CostPreviewResponse>,
): { __typename: 'CostPreviewResponse' } & CostPreviewResponse => {
    return {
        __typename: 'CostPreviewResponse',
        credits:
            overrides && overrides.hasOwnProperty('credits')
                ? overrides.credits!
                : 8043,
        remainingCredits:
            overrides && overrides.hasOwnProperty('remainingCredits')
                ? overrides.remainingCredits!
                : 7842,
        unavailabilityReason:
            overrides && overrides.hasOwnProperty('unavailabilityReason')
                ? overrides.unavailabilityReason!
                : 'conscendo',
    };
};

export const aCreatorSession = (
    overrides?: Partial<CreatorSession>,
): { __typename: 'CreatorSession' } & CreatorSession => {
    return {
        __typename: 'CreatorSession',
        bpm:
            overrides && overrides.hasOwnProperty('bpm')
                ? overrides.bpm!
                : 4116,
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : '519748e2-7658-4b53-89cd-c0abee98a508',
        isPublic:
            overrides && overrides.hasOwnProperty('isPublic')
                ? overrides.isPublic!
                : true,
        key:
            overrides && overrides.hasOwnProperty('key')
                ? overrides.key!
                : aKey(),
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'delectatio',
        samples:
            overrides && overrides.hasOwnProperty('samples')
                ? overrides.samples!
                : [aTrack()],
        userId:
            overrides && overrides.hasOwnProperty('userId')
                ? overrides.userId!
                : '584903fb-9f67-412a-876e-1eaab3e5c67f',
        version:
            overrides && overrides.hasOwnProperty('version')
                ? overrides.version!
                : 5811,
    };
};

export const aCreatorSessionInput = (
    overrides?: Partial<CreatorSessionInput>,
): CreatorSessionInput => {
    return {
        bpm:
            overrides && overrides.hasOwnProperty('bpm')
                ? overrides.bpm!
                : 3691,
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : '8d31911d-4023-4178-b229-3cad89254d57',
        isPublic:
            overrides && overrides.hasOwnProperty('isPublic')
                ? overrides.isPublic!
                : false,
        key:
            overrides && overrides.hasOwnProperty('key')
                ? overrides.key!
                : aKeyInput(),
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'voro',
        samples:
            overrides && overrides.hasOwnProperty('samples')
                ? overrides.samples!
                : [aTrackInput()],
        version:
            overrides && overrides.hasOwnProperty('version')
                ? overrides.version!
                : 2922,
    };
};

export const aCreditBalancePayloadType = (
    overrides?: Partial<CreditBalancePayloadType>,
): { __typename: 'CreditBalancePayloadType' } & CreditBalancePayloadType => {
    return {
        __typename: 'CreditBalancePayloadType',
        hdwav:
            overrides && overrides.hasOwnProperty('hdwav')
                ? overrides.hdwav!
                : aBalance(),
        mp3:
            overrides && overrides.hasOwnProperty('mp3')
                ? overrides.mp3!
                : aBalance(),
        sample:
            overrides && overrides.hasOwnProperty('sample')
                ? overrides.sample!
                : aBalance(),
        wav:
            overrides && overrides.hasOwnProperty('wav')
                ? overrides.wav!
                : aBalance(),
    };
};

export const aCurrency = (
    overrides?: Partial<Currency>,
): { __typename: 'Currency' } & Currency => {
    return {
        __typename: 'Currency',
        currencyCode:
            overrides && overrides.hasOwnProperty('currencyCode')
                ? overrides.currencyCode!
                : 'coniuratio',
        currencySymbol:
            overrides && overrides.hasOwnProperty('currencySymbol')
                ? overrides.currencySymbol!
                : 'uterque',
    };
};

export const aCurrentSubscription = (
    overrides?: Partial<CurrentSubscription>,
): { __typename: 'CurrentSubscription' } & CurrentSubscription => {
    return {
        __typename: 'CurrentSubscription',
        activationDate:
            overrides && overrides.hasOwnProperty('activationDate')
                ? overrides.activationDate!
                : 'defaeco',
        creationDate:
            overrides && overrides.hasOwnProperty('creationDate')
                ? overrides.creationDate!
                : 'spectaculum',
        endDate:
            overrides && overrides.hasOwnProperty('endDate')
                ? overrides.endDate!
                : 'officia',
        id:
            overrides && overrides.hasOwnProperty('id')
                ? overrides.id!
                : '81e12f1e-bcc5-4f21-a282-cc6969f3dfcb',
        isTrial:
            overrides && overrides.hasOwnProperty('isTrial')
                ? overrides.isTrial!
                : true,
        nextPeriodStartDate:
            overrides && overrides.hasOwnProperty('nextPeriodStartDate')
                ? overrides.nextPeriodStartDate!
                : 'suffoco',
        plan:
            overrides && overrides.hasOwnProperty('plan')
                ? overrides.plan!
                : aPlanFrequencyIdentifier(),
        segment:
            overrides && overrides.hasOwnProperty('segment')
                ? overrides.segment!
                : 'cibo',
        serviceOffer:
            overrides && overrides.hasOwnProperty('serviceOffer')
                ? overrides.serviceOffer!
                : ServiceOfferKind.Bundles,
        status:
            overrides && overrides.hasOwnProperty('status')
                ? overrides.status!
                : SubscriptionStatusEnum.Active,
    };
};

export const aCurrentSubscriptionDetails = (
    overrides?: Partial<CurrentSubscriptionDetails>,
): {
    __typename: 'CurrentSubscriptionDetails';
} & CurrentSubscriptionDetails => {
    return {
        __typename: 'CurrentSubscriptionDetails',
        billingCommitment:
            overrides && overrides.hasOwnProperty('billingCommitment')
                ? overrides.billingCommitment!
                : SubscriptionBillingCommitment.Monthly,
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'volutabrum',
        creationDate:
            overrides && overrides.hasOwnProperty('creationDate')
                ? overrides.creationDate!
                : '2021-04-24T03:17:22.046Z',
        endDate:
            overrides && overrides.hasOwnProperty('endDate')
                ? overrides.endDate!
                : '2021-04-12T02:44:30.203Z',
        frequency:
            overrides && overrides.hasOwnProperty('frequency')
                ? overrides.frequency!
                : SubscriptionFrequency.Monthly,
        grantedCredits:
            overrides && overrides.hasOwnProperty('grantedCredits')
                ? overrides.grantedCredits!
                : [aGrantedCredits()],
        id:
            overrides && overrides.hasOwnProperty('id')
                ? overrides.id!
                : '832f762d-61d1-45d7-b2a6-77b0040d6ea4',
        includedFeatures:
            overrides && overrides.hasOwnProperty('includedFeatures')
                ? overrides.includedFeatures!
                : aPlanIncludedFeatures(),
        nextPaymentAmount:
            overrides && overrides.hasOwnProperty('nextPaymentAmount')
                ? overrides.nextPaymentAmount!
                : aPrice(),
        renewalDate:
            overrides && overrides.hasOwnProperty('renewalDate')
                ? overrides.renewalDate!
                : '2021-09-24T11:38:35.442Z',
    };
};

export const aDescriptor = (
    overrides?: Partial<Descriptor>,
): { __typename: 'Descriptor' } & Descriptor => {
    return {
        __typename: 'Descriptor',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'odio',
    };
};

export const aFilter = (
    overrides?: Partial<Filter>,
): { __typename: 'Filter' } & Filter => {
    return {
        __typename: 'Filter',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'allatus',
    };
};

export const aFilterCategories = (
    overrides?: Partial<FilterCategories>,
): { __typename: 'FilterCategories' } & FilterCategories => {
    return {
        __typename: 'FilterCategories',
        genres:
            overrides && overrides.hasOwnProperty('genres')
                ? overrides.genres!
                : [aFilterFamily()],
        instruments:
            overrides && overrides.hasOwnProperty('instruments')
                ? overrides.instruments!
                : [aFilterFamily()],
        sampleTypes:
            overrides && overrides.hasOwnProperty('sampleTypes')
                ? overrides.sampleTypes!
                : [aFilter()],
        sfxs:
            overrides && overrides.hasOwnProperty('sfxs')
                ? overrides.sfxs!
                : [aFilterFamily()],
        tags:
            overrides && overrides.hasOwnProperty('tags')
                ? overrides.tags!
                : [aFilterWithLabel()],
        tagsCategories:
            overrides && overrides.hasOwnProperty('tagsCategories')
                ? overrides.tagsCategories!
                : [aTagsCategory()],
    };
};

export const aFilterFamily = (
    overrides?: Partial<FilterFamily>,
): { __typename: 'FilterFamily' } & FilterFamily => {
    return {
        __typename: 'FilterFamily',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'trepide',
        subFilters:
            overrides && overrides.hasOwnProperty('subFilters')
                ? overrides.subFilters!
                : [aFilter()],
    };
};

export const aFilterMeta = (
    overrides?: Partial<FilterMeta>,
): { __typename: 'FilterMeta' } & FilterMeta => {
    return {
        __typename: 'FilterMeta',
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'canis',
        value:
            overrides && overrides.hasOwnProperty('value')
                ? overrides.value!
                : 735,
    };
};

export const aFilterWithLabel = (
    overrides?: Partial<FilterWithLabel>,
): { __typename: 'FilterWithLabel' } & FilterWithLabel => {
    return {
        __typename: 'FilterWithLabel',
        category:
            overrides && overrides.hasOwnProperty('category')
                ? overrides.category!
                : 'sol',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'appono',
        label:
            overrides && overrides.hasOwnProperty('label')
                ? overrides.label!
                : 'depraedor',
    };
};

export const aFilters = (
    overrides?: Partial<Filters>,
): { __typename: 'Filters' } & Filters => {
    return {
        __typename: 'Filters',
        descriptorFilters:
            overrides && overrides.hasOwnProperty('descriptorFilters')
                ? overrides.descriptorFilters!
                : [aFilterMeta()],
        genreFilters:
            overrides && overrides.hasOwnProperty('genreFilters')
                ? overrides.genreFilters!
                : [aFilterMeta()],
        instrumentFilters:
            overrides && overrides.hasOwnProperty('instrumentFilters')
                ? overrides.instrumentFilters!
                : [aFilterMeta()],
        sampleTypeFilters:
            overrides && overrides.hasOwnProperty('sampleTypeFilters')
                ? overrides.sampleTypeFilters!
                : [aFilterMeta()],
        sfxFilters:
            overrides && overrides.hasOwnProperty('sfxFilters')
                ? overrides.sfxFilters!
                : [aFilterMeta()],
        tagFilters:
            overrides && overrides.hasOwnProperty('tagFilters')
                ? overrides.tagFilters!
                : [aFilterMeta()],
    };
};

export const aGenre = (
    overrides?: Partial<Genre>,
): { __typename: 'Genre' } & Genre => {
    return {
        __typename: 'Genre',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'voveo',
        subGenres:
            overrides && overrides.hasOwnProperty('subGenres')
                ? overrides.subGenres!
                : [aSubItems()],
    };
};

export const aGenreInput = (overrides?: Partial<GenreInput>): GenreInput => {
    return {
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'angulus',
        subGenres:
            overrides && overrides.hasOwnProperty('subGenres')
                ? overrides.subGenres!
                : [aGenreInput()],
    };
};

export const aGrantedCredits = (
    overrides?: Partial<GrantedCredits>,
): { __typename: 'GrantedCredits' } & GrantedCredits => {
    return {
        __typename: 'GrantedCredits',
        isUnlimited:
            overrides && overrides.hasOwnProperty('isUnlimited')
                ? overrides.isUnlimited!
                : true,
        quantity:
            overrides && overrides.hasOwnProperty('quantity')
                ? overrides.quantity!
                : 6865,
    };
};

export const aHeroBanner = (
    overrides?: Partial<HeroBanner>,
): { __typename: 'HeroBanner' } & HeroBanner => {
    return {
        __typename: 'HeroBanner',
        byline:
            overrides && overrides.hasOwnProperty('byline')
                ? overrides.byline!
                : 'cunae',
        contentType:
            overrides && overrides.hasOwnProperty('contentType')
                ? overrides.contentType!
                : HeroBannerContentType.Collection,
        customArtworkUrl:
            overrides && overrides.hasOwnProperty('customArtworkUrl')
                ? overrides.customArtworkUrl!
                : 'cattus',
        customDemoUrl:
            overrides && overrides.hasOwnProperty('customDemoUrl')
                ? overrides.customDemoUrl!
                : 'delicate',
        customTags:
            overrides && overrides.hasOwnProperty('customTags')
                ? overrides.customTags!
                : ['eius'],
        description:
            overrides && overrides.hasOwnProperty('description')
                ? overrides.description!
                : 'adfectus',
        entity:
            overrides && overrides.hasOwnProperty('entity')
                ? overrides.entity!
                : aLabel(),
        genres:
            overrides && overrides.hasOwnProperty('genres')
                ? overrides.genres!
                : [aGenre()],
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : 'turbo',
        instruments:
            overrides && overrides.hasOwnProperty('instruments')
                ? overrides.instruments!
                : [anInstrument()],
        labelPacks:
            overrides && overrides.hasOwnProperty('labelPacks')
                ? overrides.labelPacks!
                : [aPack()],
        title:
            overrides && overrides.hasOwnProperty('title')
                ? overrides.title!
                : 'anser',
    };
};

export const anInstrument = (
    overrides?: Partial<Instrument>,
): { __typename: 'Instrument' } & Instrument => {
    return {
        __typename: 'Instrument',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'tergiversatio',
        isFamily:
            overrides && overrides.hasOwnProperty('isFamily')
                ? overrides.isFamily!
                : true,
        subInstruments:
            overrides && overrides.hasOwnProperty('subInstruments')
                ? overrides.subInstruments!
                : [aSubItems()],
    };
};

export const anInstrumentInput = (
    overrides?: Partial<InstrumentInput>,
): InstrumentInput => {
    return {
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'corrupti',
        isFamily:
            overrides && overrides.hasOwnProperty('isFamily')
                ? overrides.isFamily!
                : true,
        subInstruments:
            overrides && overrides.hasOwnProperty('subInstruments')
                ? overrides.subInstruments!
                : [anInstrumentInput()],
    };
};

export const aKey = (overrides?: Partial<Key>): { __typename: 'Key' } & Key => {
    return {
        __typename: 'Key',
        quality:
            overrides && overrides.hasOwnProperty('quality')
                ? overrides.quality!
                : KeyQuality.Major,
        root:
            overrides && overrides.hasOwnProperty('root')
                ? overrides.root!
                : KeyRootApi.A,
        sign:
            overrides && overrides.hasOwnProperty('sign')
                ? overrides.sign!
                : KeySign.Flat,
    };
};

export const aKeyInput = (overrides?: Partial<KeyInput>): KeyInput => {
    return {
        quality:
            overrides && overrides.hasOwnProperty('quality')
                ? overrides.quality!
                : KeyQuality.Major,
        root:
            overrides && overrides.hasOwnProperty('root')
                ? overrides.root!
                : KeyRootApi.A,
        sign:
            overrides && overrides.hasOwnProperty('sign')
                ? overrides.sign!
                : KeySign.Flat,
    };
};

export const aLabel = (
    overrides?: Partial<Label>,
): { __typename: 'Label' } & Label => {
    return {
        __typename: 'Label',
        artworkUrl:
            overrides && overrides.hasOwnProperty('artworkUrl')
                ? overrides.artworkUrl!
                : 'denego',
        coverUrl:
            overrides && overrides.hasOwnProperty('coverUrl')
                ? overrides.coverUrl!
                : 'excepturi',
        description:
            overrides && overrides.hasOwnProperty('description')
                ? overrides.description!
                : 'tres',
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : 'd5ae1a36-3497-4aba-adaa-76eb907453d7',
        isExclusive:
            overrides && overrides.hasOwnProperty('isExclusive')
                ? overrides.isExclusive!
                : true,
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'conturbo',
        packCount:
            overrides && overrides.hasOwnProperty('packCount')
                ? overrides.packCount!
                : 9769,
        sampleCount:
            overrides && overrides.hasOwnProperty('sampleCount')
                ? overrides.sampleCount!
                : 7365,
        slug:
            overrides && overrides.hasOwnProperty('slug')
                ? overrides.slug!
                : 'tot',
    };
};

export const aLabelsChart = (
    overrides?: Partial<LabelsChart>,
): { __typename: 'LabelsChart' } & LabelsChart => {
    return {
        __typename: 'LabelsChart',
        items:
            overrides && overrides.hasOwnProperty('items')
                ? overrides.items!
                : [aLabelsChartItem()],
    };
};

export const aLabelsChartItem = (
    overrides?: Partial<LabelsChartItem>,
): { __typename: 'LabelsChartItem' } & LabelsChartItem => {
    return {
        __typename: 'LabelsChartItem',
        artistName:
            overrides && overrides.hasOwnProperty('artistName')
                ? overrides.artistName!
                : 'somniculosus',
        artworkUrl:
            overrides && overrides.hasOwnProperty('artworkUrl')
                ? overrides.artworkUrl!
                : 'censura',
        currentRank:
            overrides && overrides.hasOwnProperty('currentRank')
                ? overrides.currentRank!
                : 8050,
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : '6105df85-c1ab-41bc-84e1-a3898ac2c67c',
        isNew:
            overrides && overrides.hasOwnProperty('isNew')
                ? overrides.isNew!
                : false,
        lastRank:
            overrides && overrides.hasOwnProperty('lastRank')
                ? overrides.lastRank!
                : 719,
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'provident',
        slug:
            overrides && overrides.hasOwnProperty('slug')
                ? overrides.slug!
                : 'sortitus',
        subItemsCount:
            overrides && overrides.hasOwnProperty('subItemsCount')
                ? overrides.subItemsCount!
                : 5143,
    };
};

export const aMerchZone = (
    overrides?: Partial<MerchZone>,
): { __typename: 'MerchZone' } & MerchZone => {
    return {
        __typename: 'MerchZone',
        contentGroups:
            overrides && overrides.hasOwnProperty('contentGroups')
                ? overrides.contentGroups!
                : [aContentGroup()],
    };
};

export const aMetaPage = (
    overrides?: Partial<MetaPage>,
): { __typename: 'MetaPage' } & MetaPage => {
    return {
        __typename: 'MetaPage',
        filters:
            overrides && overrides.hasOwnProperty('filters')
                ? overrides.filters!
                : aFilters(),
        totalPackRecords:
            overrides && overrides.hasOwnProperty('totalPackRecords')
                ? overrides.totalPackRecords!
                : 8957,
        totalRecords:
            overrides && overrides.hasOwnProperty('totalRecords')
                ? overrides.totalRecords!
                : 7219,
        totalRepackRecords:
            overrides && overrides.hasOwnProperty('totalRepackRecords')
                ? overrides.totalRepackRecords!
                : 3703,
        totalSampleRecords:
            overrides && overrides.hasOwnProperty('totalSampleRecords')
                ? overrides.totalSampleRecords!
                : 2624,
    };
};

export const aMutation = (
    overrides?: Partial<Mutation>,
): { __typename: 'Mutation' } & Mutation => {
    return {
        __typename: 'Mutation',
        acceptUserAgreements:
            overrides && overrides.hasOwnProperty('acceptUserAgreements')
                ? overrides.acceptUserAgreements!
                : false,
        activateTrialSubscription:
            overrides && overrides.hasOwnProperty('activateTrialSubscription')
                ? overrides.activateTrialSubscription!
                : aSubscriptionsAndAllowedFeatures(),
        addSamplesToUserCollection:
            overrides && overrides.hasOwnProperty('addSamplesToUserCollection')
                ? overrides.addSamplesToUserCollection!
                : aUserCollection(),
        createUserCollection:
            overrides && overrides.hasOwnProperty('createUserCollection')
                ? overrides.createUserCollection!
                : aUserCollection(),
        createUserRecentSearch:
            overrides && overrides.hasOwnProperty('createUserRecentSearch')
                ? overrides.createUserRecentSearch!
                : 'dens',
        deleteUserCollection:
            overrides && overrides.hasOwnProperty('deleteUserCollection')
                ? overrides.deleteUserCollection!
                : 'degero',
        deleteUserRecentSearch:
            overrides && overrides.hasOwnProperty('deleteUserRecentSearch')
                ? overrides.deleteUserRecentSearch!
                : 'deludo',
        editUserCollection:
            overrides && overrides.hasOwnProperty('editUserCollection')
                ? overrides.editUserCollection!
                : 'desino',
        putMilestones:
            overrides && overrides.hasOwnProperty('putMilestones')
                ? overrides.putMilestones!
                : ['casus'],
        removeSamplesFromUserCollection:
            overrides &&
            overrides.hasOwnProperty('removeSamplesFromUserCollection')
                ? overrides.removeSamplesFromUserCollection!
                : aUserCollection(),
        storeCreatorSession:
            overrides && overrides.hasOwnProperty('storeCreatorSession')
                ? overrides.storeCreatorSession!
                : aCreatorSession(),
        updatePackFavoritedState:
            overrides && overrides.hasOwnProperty('updatePackFavoritedState')
                ? overrides.updatePackFavoritedState!
                : aPack(),
        updateRepackFavoritedState:
            overrides && overrides.hasOwnProperty('updateRepackFavoritedState')
                ? overrides.updateRepackFavoritedState!
                : aRepack(),
        updateSampleFavoritedState:
            overrides && overrides.hasOwnProperty('updateSampleFavoritedState')
                ? overrides.updateSampleFavoritedState!
                : aSample(),
    };
};

export const aNextPage = (
    overrides?: Partial<NextPage>,
): { __typename: 'NextPage' } & NextPage => {
    return {
        __typename: 'NextPage',
        skip:
            overrides && overrides.hasOwnProperty('skip')
                ? overrides.skip!
                : 5911,
    };
};

export const anOverduePayment = (
    overrides?: Partial<OverduePayment>,
): { __typename: 'OverduePayment' } & OverduePayment => {
    return {
        __typename: 'OverduePayment',
        serviceOffer:
            overrides && overrides.hasOwnProperty('serviceOffer')
                ? overrides.serviceOffer!
                : ServiceOfferKind.Bundles,
    };
};

export const aPack = (
    overrides?: Partial<Pack>,
): { __typename: 'Pack' } & Pack => {
    return {
        __typename: 'Pack',
        artist:
            overrides && overrides.hasOwnProperty('artist')
                ? overrides.artist!
                : anArtist(),
        artworkUrl:
            overrides && overrides.hasOwnProperty('artworkUrl')
                ? overrides.artworkUrl!
                : 'ipsa',
        backgroundColor:
            overrides && overrides.hasOwnProperty('backgroundColor')
                ? overrides.backgroundColor!
                : 'thalassinus',
        creatorSession:
            overrides && overrides.hasOwnProperty('creatorSession')
                ? overrides.creatorSession!
                : '594aa2b9-6266-42b5-8de3-2cb2fc67d36b',
        description:
            overrides && overrides.hasOwnProperty('description')
                ? overrides.description!
                : 'verumtamen',
        foregroundColor:
            overrides && overrides.hasOwnProperty('foregroundColor')
                ? overrides.foregroundColor!
                : 'delectus',
        genres:
            overrides && overrides.hasOwnProperty('genres')
                ? overrides.genres!
                : [aGenre()],
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : 'b5a43f37-8da7-43c4-b3e7-e7fbba52d490',
        isDownloaded:
            overrides && overrides.hasOwnProperty('isDownloaded')
                ? overrides.isDownloaded!
                : false,
        isExclusive:
            overrides && overrides.hasOwnProperty('isExclusive')
                ? overrides.isExclusive!
                : true,
        isFavorited:
            overrides && overrides.hasOwnProperty('isFavorited')
                ? overrides.isFavorited!
                : true,
        isFree:
            overrides && overrides.hasOwnProperty('isFree')
                ? overrides.isFree!
                : true,
        label:
            overrides && overrides.hasOwnProperty('label')
                ? overrides.label!
                : aLabel(),
        mainGenre:
            overrides && overrides.hasOwnProperty('mainGenre')
                ? overrides.mainGenre!
                : aGenre(),
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'claro',
        packState:
            overrides && overrides.hasOwnProperty('packState')
                ? overrides.packState!
                : PackState.Draft,
        premiumCodes:
            overrides && overrides.hasOwnProperty('premiumCodes')
                ? overrides.premiumCodes!
                : [PremiumCodes.LandrStudio],
        sampleCount:
            overrides && overrides.hasOwnProperty('sampleCount')
                ? overrides.sampleCount!
                : 1635,
        sfxs:
            overrides && overrides.hasOwnProperty('sfxs')
                ? overrides.sfxs!
                : [aSfx()],
        slug:
            overrides && overrides.hasOwnProperty('slug')
                ? overrides.slug!
                : 'color',
        type:
            overrides && overrides.hasOwnProperty('type')
                ? overrides.type!
                : PackType.Pack,
    };
};

export const aPackFavoritedInput = (
    overrides?: Partial<PackFavoritedInput>,
): PackFavoritedInput => {
    return {
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : '1e280df6-a296-4a58-b710-60f63e2afb15',
        isFavorited:
            overrides && overrides.hasOwnProperty('isFavorited')
                ? overrides.isFavorited!
                : false,
    };
};

export const aPackagesMeta = (
    overrides?: Partial<PackagesMeta>,
): { __typename: 'PackagesMeta' } & PackagesMeta => {
    return {
        __typename: 'PackagesMeta',
        url:
            overrides && overrides.hasOwnProperty('url')
                ? overrides.url!
                : 'causa',
        version:
            overrides && overrides.hasOwnProperty('version')
                ? overrides.version!
                : 'traho',
    };
};

export const aPacksChart = (
    overrides?: Partial<PacksChart>,
): { __typename: 'PacksChart' } & PacksChart => {
    return {
        __typename: 'PacksChart',
        items:
            overrides && overrides.hasOwnProperty('items')
                ? overrides.items!
                : [aPacksChartItem()],
    };
};

export const aPacksChartItem = (
    overrides?: Partial<PacksChartItem>,
): { __typename: 'PacksChartItem' } & PacksChartItem => {
    return {
        __typename: 'PacksChartItem',
        artistName:
            overrides && overrides.hasOwnProperty('artistName')
                ? overrides.artistName!
                : 'sit',
        artworkUrl:
            overrides && overrides.hasOwnProperty('artworkUrl')
                ? overrides.artworkUrl!
                : 'timor',
        currentRank:
            overrides && overrides.hasOwnProperty('currentRank')
                ? overrides.currentRank!
                : 7458,
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : '9f8d4401-db2f-45bb-a250-50a8ada34bc0',
        isNew:
            overrides && overrides.hasOwnProperty('isNew')
                ? overrides.isNew!
                : false,
        lastRank:
            overrides && overrides.hasOwnProperty('lastRank')
                ? overrides.lastRank!
                : 3877,
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'comedo',
        slug:
            overrides && overrides.hasOwnProperty('slug')
                ? overrides.slug!
                : 'thesis',
        subItemsCount:
            overrides && overrides.hasOwnProperty('subItemsCount')
                ? overrides.subItemsCount!
                : 6076,
    };
};

export const aPaginatedArtists = (
    overrides?: Partial<PaginatedArtists>,
): { __typename: 'PaginatedArtists' } & PaginatedArtists => {
    return {
        __typename: 'PaginatedArtists',
        data:
            overrides && overrides.hasOwnProperty('data')
                ? overrides.data!
                : [anArtist()],
        meta:
            overrides && overrides.hasOwnProperty('meta')
                ? overrides.meta!
                : aMetaPage(),
        next:
            overrides && overrides.hasOwnProperty('next')
                ? overrides.next!
                : aNextPage(),
    };
};

export const aPaginatedLabels = (
    overrides?: Partial<PaginatedLabels>,
): { __typename: 'PaginatedLabels' } & PaginatedLabels => {
    return {
        __typename: 'PaginatedLabels',
        data:
            overrides && overrides.hasOwnProperty('data')
                ? overrides.data!
                : [aLabel()],
        meta:
            overrides && overrides.hasOwnProperty('meta')
                ? overrides.meta!
                : aMetaPage(),
        next:
            overrides && overrides.hasOwnProperty('next')
                ? overrides.next!
                : aNextPage(),
    };
};

export const aPaginatedPacks = (
    overrides?: Partial<PaginatedPacks>,
): { __typename: 'PaginatedPacks' } & PaginatedPacks => {
    return {
        __typename: 'PaginatedPacks',
        data:
            overrides && overrides.hasOwnProperty('data')
                ? overrides.data!
                : [aPack()],
        meta:
            overrides && overrides.hasOwnProperty('meta')
                ? overrides.meta!
                : aMetaPage(),
        next:
            overrides && overrides.hasOwnProperty('next')
                ? overrides.next!
                : aNextPage(),
    };
};

export const aPaginatedPacksOrRepacks = (
    overrides?: Partial<PaginatedPacksOrRepacks>,
): { __typename: 'PaginatedPacksOrRepacks' } & PaginatedPacksOrRepacks => {
    return {
        __typename: 'PaginatedPacksOrRepacks',
        data:
            overrides && overrides.hasOwnProperty('data')
                ? overrides.data!
                : [aPack()],
        meta:
            overrides && overrides.hasOwnProperty('meta')
                ? overrides.meta!
                : aMetaPage(),
        next:
            overrides && overrides.hasOwnProperty('next')
                ? overrides.next!
                : aNextPage(),
    };
};

export const aPaginatedRepacks = (
    overrides?: Partial<PaginatedRepacks>,
): { __typename: 'PaginatedRepacks' } & PaginatedRepacks => {
    return {
        __typename: 'PaginatedRepacks',
        data:
            overrides && overrides.hasOwnProperty('data')
                ? overrides.data!
                : [aRepack()],
        meta:
            overrides && overrides.hasOwnProperty('meta')
                ? overrides.meta!
                : aMetaPage(),
        next:
            overrides && overrides.hasOwnProperty('next')
                ? overrides.next!
                : aNextPage(),
    };
};

export const aPaginatedSamples = (
    overrides?: Partial<PaginatedSamples>,
): { __typename: 'PaginatedSamples' } & PaginatedSamples => {
    return {
        __typename: 'PaginatedSamples',
        data:
            overrides && overrides.hasOwnProperty('data')
                ? overrides.data!
                : [aSample()],
        meta:
            overrides && overrides.hasOwnProperty('meta')
                ? overrides.meta!
                : aMetaPage(),
        next:
            overrides && overrides.hasOwnProperty('next')
                ? overrides.next!
                : aNextPage(),
    };
};

export const aPaginatedUserCollections = (
    overrides?: Partial<PaginatedUserCollections>,
): { __typename: 'PaginatedUserCollections' } & PaginatedUserCollections => {
    return {
        __typename: 'PaginatedUserCollections',
        data:
            overrides && overrides.hasOwnProperty('data')
                ? overrides.data!
                : [aUserCollection()],
        meta:
            overrides && overrides.hasOwnProperty('meta')
                ? overrides.meta!
                : aMetaPage(),
        next:
            overrides && overrides.hasOwnProperty('next')
                ? overrides.next!
                : aNextPage(),
    };
};

export const aPlanFrequencyIdentifier = (
    overrides?: Partial<PlanFrequencyIdentifier>,
): { __typename: 'PlanFrequencyIdentifier' } & PlanFrequencyIdentifier => {
    return {
        __typename: 'PlanFrequencyIdentifier',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'conitor',
        frequency:
            overrides && overrides.hasOwnProperty('frequency')
                ? overrides.frequency!
                : Interval.Monthly,
    };
};

export const aPlanIncludedFeatures = (
    overrides?: Partial<PlanIncludedFeatures>,
): { __typename: 'PlanIncludedFeatures' } & PlanIncludedFeatures => {
    return {
        __typename: 'PlanIncludedFeatures',
        id:
            overrides && overrides.hasOwnProperty('id')
                ? overrides.id!
                : '531714f0-00b2-4a4a-933b-8ad6b4f8083d',
        samples:
            overrides && overrides.hasOwnProperty('samples')
                ? overrides.samples!
                : aSamplesIncludedFeature(),
    };
};

export const aPluginPackages = (
    overrides?: Partial<PluginPackages>,
): { __typename: 'PluginPackages' } & PluginPackages => {
    return {
        __typename: 'PluginPackages',
        macOS:
            overrides && overrides.hasOwnProperty('macOS')
                ? overrides.macOS!
                : aPackagesMeta(),
        windows:
            overrides && overrides.hasOwnProperty('windows')
                ? overrides.windows!
                : aPackagesMeta(),
    };
};

export const aPrice = (
    overrides?: Partial<Price>,
): { __typename: 'Price' } & Price => {
    return {
        __typename: 'Price',
        currency:
            overrides && overrides.hasOwnProperty('currency')
                ? overrides.currency!
                : aCurrency(),
        value:
            overrides && overrides.hasOwnProperty('value')
                ? overrides.value!
                : 3.3,
    };
};

export const aPrismicBackgroundImage = (
    overrides?: Partial<PrismicBackgroundImage>,
): { __typename: 'PrismicBackgroundImage' } & PrismicBackgroundImage => {
    return {
        __typename: 'PrismicBackgroundImage',
        alt:
            overrides && overrides.hasOwnProperty('alt')
                ? overrides.alt!
                : 'vestigium',
        copyright:
            overrides && overrides.hasOwnProperty('copyright')
                ? overrides.copyright!
                : 'teres',
        dimensions:
            overrides && overrides.hasOwnProperty('dimensions')
                ? overrides.dimensions!
                : aPrismicImageDimensions(),
        regular:
            overrides && overrides.hasOwnProperty('regular')
                ? overrides.regular!
                : aPrismicImage(),
        url:
            overrides && overrides.hasOwnProperty('url')
                ? overrides.url!
                : 'denique',
    };
};

export const aPrismicBanner = (
    overrides?: Partial<PrismicBanner>,
): { __typename: 'PrismicBanner' } & PrismicBanner => {
    return {
        __typename: 'PrismicBanner',
        first_publication_date:
            overrides && overrides.hasOwnProperty('first_publication_date')
                ? overrides.first_publication_date!
                : '2021-06-14T07:59:24.553Z',
        id:
            overrides && overrides.hasOwnProperty('id')
                ? overrides.id!
                : '1dde0f59-a779-427c-ad0f-516d608f0ea6',
        isBroken:
            overrides && overrides.hasOwnProperty('isBroken')
                ? overrides.isBroken!
                : false,
        lang:
            overrides && overrides.hasOwnProperty('lang')
                ? overrides.lang!
                : 'stillicidium',
        last_publication_date:
            overrides && overrides.hasOwnProperty('last_publication_date')
                ? overrides.last_publication_date!
                : '2021-06-16T09:24:35.662Z',
        link_type:
            overrides && overrides.hasOwnProperty('link_type')
                ? overrides.link_type!
                : 'umquam',
        slug:
            overrides && overrides.hasOwnProperty('slug')
                ? overrides.slug!
                : 'depraedor',
        tags:
            overrides && overrides.hasOwnProperty('tags')
                ? overrides.tags!
                : ['avarus'],
        type:
            overrides && overrides.hasOwnProperty('type')
                ? overrides.type!
                : 'adduco',
    };
};

export const aPrismicDocument = (
    overrides?: Partial<PrismicDocument>,
): { __typename: 'PrismicDocument' } & PrismicDocument => {
    return {
        __typename: 'PrismicDocument',
        alternate_languages:
            overrides && overrides.hasOwnProperty('alternate_languages')
                ? overrides.alternate_languages!
                : [anAlternateLanguage()],
        data:
            overrides && overrides.hasOwnProperty('data')
                ? overrides.data!
                : aPrismicSampleAuthBannerData(),
        first_publication_date:
            overrides && overrides.hasOwnProperty('first_publication_date')
                ? overrides.first_publication_date!
                : 'abundans',
        href:
            overrides && overrides.hasOwnProperty('href')
                ? overrides.href!
                : 'capillus',
        id:
            overrides && overrides.hasOwnProperty('id')
                ? overrides.id!
                : 'deb64cec-a45d-4ba9-acef-c6e7192d42d6',
        lang:
            overrides && overrides.hasOwnProperty('lang')
                ? overrides.lang!
                : 'eius',
        last_publication_date:
            overrides && overrides.hasOwnProperty('last_publication_date')
                ? overrides.last_publication_date!
                : 'vix',
        slugs:
            overrides && overrides.hasOwnProperty('slugs')
                ? overrides.slugs!
                : ['supra'],
        tags:
            overrides && overrides.hasOwnProperty('tags')
                ? overrides.tags!
                : ['colligo'],
        type:
            overrides && overrides.hasOwnProperty('type')
                ? overrides.type!
                : 'demens',
        uid:
            overrides && overrides.hasOwnProperty('uid')
                ? overrides.uid!
                : 'voluptates',
    };
};

export const aPrismicImage = (
    overrides?: Partial<PrismicImage>,
): { __typename: 'PrismicImage' } & PrismicImage => {
    return {
        __typename: 'PrismicImage',
        alt:
            overrides && overrides.hasOwnProperty('alt')
                ? overrides.alt!
                : 'virga',
        copyright:
            overrides && overrides.hasOwnProperty('copyright')
                ? overrides.copyright!
                : 'officiis',
        dimensions:
            overrides && overrides.hasOwnProperty('dimensions')
                ? overrides.dimensions!
                : aPrismicImageDimensions(),
        url:
            overrides && overrides.hasOwnProperty('url')
                ? overrides.url!
                : 'veniam',
    };
};

export const aPrismicImageDimensions = (
    overrides?: Partial<PrismicImageDimensions>,
): { __typename: 'PrismicImageDimensions' } & PrismicImageDimensions => {
    return {
        __typename: 'PrismicImageDimensions',
        height:
            overrides && overrides.hasOwnProperty('height')
                ? overrides.height!
                : 2323,
        width:
            overrides && overrides.hasOwnProperty('width')
                ? overrides.width!
                : 9060,
    };
};

export const aPrismicSampleAuthBannerCtaLink = (
    overrides?: Partial<PrismicSampleAuthBannerCtaLink>,
): {
    __typename: 'PrismicSampleAuthBannerCtaLink';
} & PrismicSampleAuthBannerCtaLink => {
    return {
        __typename: 'PrismicSampleAuthBannerCtaLink',
        authenticated_cta_link:
            overrides && overrides.hasOwnProperty('authenticated_cta_link')
                ? overrides.authenticated_cta_link!
                : [aPrismicTextField()],
        guest_cta_link:
            overrides && overrides.hasOwnProperty('guest_cta_link')
                ? overrides.guest_cta_link!
                : [aPrismicTextField()],
    };
};

export const aPrismicSampleAuthBannerCtaText = (
    overrides?: Partial<PrismicSampleAuthBannerCtaText>,
): {
    __typename: 'PrismicSampleAuthBannerCtaText';
} & PrismicSampleAuthBannerCtaText => {
    return {
        __typename: 'PrismicSampleAuthBannerCtaText',
        authenticated_cta_text:
            overrides && overrides.hasOwnProperty('authenticated_cta_text')
                ? overrides.authenticated_cta_text!
                : [aPrismicTextField()],
        guest_cta_text:
            overrides && overrides.hasOwnProperty('guest_cta_text')
                ? overrides.guest_cta_text!
                : [aPrismicTextField()],
    };
};

export const aPrismicSampleAuthBannerData = (
    overrides?: Partial<PrismicSampleAuthBannerData>,
): {
    __typename: 'PrismicSampleAuthBannerData';
} & PrismicSampleAuthBannerData => {
    return {
        __typename: 'PrismicSampleAuthBannerData',
        background_image:
            overrides && overrides.hasOwnProperty('background_image')
                ? overrides.background_image!
                : aPrismicBackgroundImage(),
        banner_title:
            overrides && overrides.hasOwnProperty('banner_title')
                ? overrides.banner_title!
                : [aPrismicTextField()],
        cta_link:
            overrides && overrides.hasOwnProperty('cta_link')
                ? overrides.cta_link!
                : [aPrismicSampleAuthBannerCtaLink()],
        cta_text:
            overrides && overrides.hasOwnProperty('cta_text')
                ? overrides.cta_text!
                : [aPrismicSampleAuthBannerCtaText()],
        description:
            overrides && overrides.hasOwnProperty('description')
                ? overrides.description!
                : [aPrismicSampleAuthBannerDescription()],
        title:
            overrides && overrides.hasOwnProperty('title')
                ? overrides.title!
                : [aPrismicSampleAuthBannerTitle()],
    };
};

export const aPrismicSampleAuthBannerDescription = (
    overrides?: Partial<PrismicSampleAuthBannerDescription>,
): {
    __typename: 'PrismicSampleAuthBannerDescription';
} & PrismicSampleAuthBannerDescription => {
    return {
        __typename: 'PrismicSampleAuthBannerDescription',
        authenticated_description:
            overrides && overrides.hasOwnProperty('authenticated_description')
                ? overrides.authenticated_description!
                : [aPrismicTextField()],
        guest_description:
            overrides && overrides.hasOwnProperty('guest_description')
                ? overrides.guest_description!
                : [aPrismicTextField()],
    };
};

export const aPrismicSampleAuthBannerTitle = (
    overrides?: Partial<PrismicSampleAuthBannerTitle>,
): {
    __typename: 'PrismicSampleAuthBannerTitle';
} & PrismicSampleAuthBannerTitle => {
    return {
        __typename: 'PrismicSampleAuthBannerTitle',
        authenticated_title:
            overrides && overrides.hasOwnProperty('authenticated_title')
                ? overrides.authenticated_title!
                : [aPrismicTextField()],
        guest_title:
            overrides && overrides.hasOwnProperty('guest_title')
                ? overrides.guest_title!
                : [aPrismicTextField()],
    };
};

export const aPrismicSampleBannerData = (
    overrides?: Partial<PrismicSampleBannerData>,
): { __typename: 'PrismicSampleBannerData' } & PrismicSampleBannerData => {
    return {
        __typename: 'PrismicSampleBannerData',
        background_color:
            overrides && overrides.hasOwnProperty('background_color')
                ? overrides.background_color!
                : 'charisma',
        background_image:
            overrides && overrides.hasOwnProperty('background_image')
                ? overrides.background_image!
                : aPrismicBackgroundImage(),
        banner_title:
            overrides && overrides.hasOwnProperty('banner_title')
                ? overrides.banner_title!
                : [aPrismicTextField()],
        cta_path:
            overrides && overrides.hasOwnProperty('cta_path')
                ? overrides.cta_path!
                : [aPrismicTextField()],
        cta_text:
            overrides && overrides.hasOwnProperty('cta_text')
                ? overrides.cta_text!
                : [aPrismicTextField()],
        description:
            overrides && overrides.hasOwnProperty('description')
                ? overrides.description!
                : [aPrismicTextField()],
        title:
            overrides && overrides.hasOwnProperty('title')
                ? overrides.title!
                : [aPrismicTextField()],
    };
};

export const aPrismicSampleBannerGroupData = (
    overrides?: Partial<PrismicSampleBannerGroupData>,
): {
    __typename: 'PrismicSampleBannerGroupData';
} & PrismicSampleBannerGroupData => {
    return {
        __typename: 'PrismicSampleBannerGroupData',
        banner_a:
            overrides && overrides.hasOwnProperty('banner_a')
                ? overrides.banner_a!
                : aPrismicBanner(),
        banner_b:
            overrides && overrides.hasOwnProperty('banner_b')
                ? overrides.banner_b!
                : aPrismicBanner(),
        banner_c:
            overrides && overrides.hasOwnProperty('banner_c')
                ? overrides.banner_c!
                : aPrismicBanner(),
        banner_d:
            overrides && overrides.hasOwnProperty('banner_d')
                ? overrides.banner_d!
                : aPrismicBanner(),
        banner_e:
            overrides && overrides.hasOwnProperty('banner_e')
                ? overrides.banner_e!
                : aPrismicBanner(),
        title:
            overrides && overrides.hasOwnProperty('title')
                ? overrides.title!
                : [aPrismicTextField()],
    };
};

export const aPrismicTextField = (
    overrides?: Partial<PrismicTextField>,
): { __typename: 'PrismicTextField' } & PrismicTextField => {
    return {
        __typename: 'PrismicTextField',
        spans:
            overrides && overrides.hasOwnProperty('spans')
                ? overrides.spans!
                : ['candidus'],
        text:
            overrides && overrides.hasOwnProperty('text')
                ? overrides.text!
                : 'sophismata',
        type:
            overrides && overrides.hasOwnProperty('type')
                ? overrides.type!
                : 'maxime',
    };
};

export const aPurchasableCreatorSample = (
    overrides?: Partial<PurchasableCreatorSample>,
): PurchasableCreatorSample => {
    return {
        gainDb:
            overrides && overrides.hasOwnProperty('gainDb')
                ? overrides.gainDb!
                : 7.1,
        id:
            overrides && overrides.hasOwnProperty('id')
                ? overrides.id!
                : 'defungo',
        semitoneShift:
            overrides && overrides.hasOwnProperty('semitoneShift')
                ? overrides.semitoneShift!
                : 2.6,
        timeFactor:
            overrides && overrides.hasOwnProperty('timeFactor')
                ? overrides.timeFactor!
                : 1.1,
    };
};

export const aPurchasableCreatorSession = (
    overrides?: Partial<PurchasableCreatorSession>,
): PurchasableCreatorSession => {
    return {
        async:
            overrides && overrides.hasOwnProperty('async')
                ? overrides.async!
                : true,
        samples:
            overrides && overrides.hasOwnProperty('samples')
                ? overrides.samples!
                : [aPurchasableCreatorSample()],
        targetBpm:
            overrides && overrides.hasOwnProperty('targetBpm')
                ? overrides.targetBpm!
                : 3233,
        targetKey:
            overrides && overrides.hasOwnProperty('targetKey')
                ? overrides.targetKey!
                : 'iure',
        targetKeyQuality:
            overrides && overrides.hasOwnProperty('targetKeyQuality')
                ? overrides.targetKeyQuality!
                : 'tabula',
        targetKeyRoot:
            overrides && overrides.hasOwnProperty('targetKeyRoot')
                ? overrides.targetKeyRoot!
                : 'deleo',
    };
};

export const aPurchaseResponse = (
    overrides?: Partial<PurchaseResponse>,
): { __typename: 'PurchaseResponse' } & PurchaseResponse => {
    return {
        __typename: 'PurchaseResponse',
        url:
            overrides && overrides.hasOwnProperty('url')
                ? overrides.url!
                : 'succurro',
    };
};

export const aQuery = (
    overrides?: Partial<Query>,
): { __typename: 'Query' } & Query => {
    return {
        __typename: 'Query',
        accountBalanceSummary:
            overrides && overrides.hasOwnProperty('accountBalanceSummary')
                ? overrides.accountBalanceSummary!
                : anAccountBalanceSummary(),
        artistBySlug:
            overrides && overrides.hasOwnProperty('artistBySlug')
                ? overrides.artistBySlug!
                : anArtist(),
        bannerGroup:
            overrides && overrides.hasOwnProperty('bannerGroup')
                ? overrides.bannerGroup!
                : [aPrismicDocument()],
        brandtypeBySlug:
            overrides && overrides.hasOwnProperty('brandtypeBySlug')
                ? overrides.brandtypeBySlug!
                : aBrandtype(),
        chartsTopLabels:
            overrides && overrides.hasOwnProperty('chartsTopLabels')
                ? overrides.chartsTopLabels!
                : aLabelsChart(),
        chartsTopLandrPacks:
            overrides && overrides.hasOwnProperty('chartsTopLandrPacks')
                ? overrides.chartsTopLandrPacks!
                : aRepacksChart(),
        chartsTopPacks:
            overrides && overrides.hasOwnProperty('chartsTopPacks')
                ? overrides.chartsTopPacks!
                : aPacksChart(),
        collectionCostPreview:
            overrides && overrides.hasOwnProperty('collectionCostPreview')
                ? overrides.collectionCostPreview!
                : aCostPreviewResponse(),
        collectionPurchase:
            overrides && overrides.hasOwnProperty('collectionPurchase')
                ? overrides.collectionPurchase!
                : aPurchaseResponse(),
        contentGroup:
            overrides && overrides.hasOwnProperty('contentGroup')
                ? overrides.contentGroup!
                : aContentGroup(),
        creatorMixdownPurchase:
            overrides && overrides.hasOwnProperty('creatorMixdownPurchase')
                ? overrides.creatorMixdownPurchase!
                : aPurchaseResponse(),
        creatorSamplesCostPreview:
            overrides && overrides.hasOwnProperty('creatorSamplesCostPreview')
                ? overrides.creatorSamplesCostPreview!
                : aCostPreviewResponse(),
        creatorSamplesPurchase:
            overrides && overrides.hasOwnProperty('creatorSamplesPurchase')
                ? overrides.creatorSamplesPurchase!
                : aPurchaseResponse(),
        creatorSessionById:
            overrides && overrides.hasOwnProperty('creatorSessionById')
                ? overrides.creatorSessionById!
                : aCreatorSession(),
        filters:
            overrides && overrides.hasOwnProperty('filters')
                ? overrides.filters!
                : aFilterCategories(),
        getUserRecentSearch:
            overrides && overrides.hasOwnProperty('getUserRecentSearch')
                ? overrides.getUserRecentSearch!
                : aUserRecentSearches(),
        heroBanners:
            overrides && overrides.hasOwnProperty('heroBanners')
                ? overrides.heroBanners!
                : [aHeroBanner()],
        labelBySlug:
            overrides && overrides.hasOwnProperty('labelBySlug')
                ? overrides.labelBySlug!
                : aLabel(),
        merchZone:
            overrides && overrides.hasOwnProperty('merchZone')
                ? overrides.merchZone!
                : aMerchZone(),
        milestones:
            overrides && overrides.hasOwnProperty('milestones')
                ? overrides.milestones!
                : ['capillus'],
        pack:
            overrides && overrides.hasOwnProperty('pack')
                ? overrides.pack!
                : aPack(),
        packCostPreview:
            overrides && overrides.hasOwnProperty('packCostPreview')
                ? overrides.packCostPreview!
                : aCostPreviewResponse(),
        packPurchase:
            overrides && overrides.hasOwnProperty('packPurchase')
                ? overrides.packPurchase!
                : aPurchaseResponse(),
        packStream:
            overrides && overrides.hasOwnProperty('packStream')
                ? overrides.packStream!
                : aStreamUrl(),
        paginatedArtistPacks:
            overrides && overrides.hasOwnProperty('paginatedArtistPacks')
                ? overrides.paginatedArtistPacks!
                : aPaginatedPacks(),
        paginatedArtistSamples:
            overrides && overrides.hasOwnProperty('paginatedArtistSamples')
                ? overrides.paginatedArtistSamples!
                : aPaginatedSamples(),
        paginatedArtists:
            overrides && overrides.hasOwnProperty('paginatedArtists')
                ? overrides.paginatedArtists!
                : aPaginatedArtists(),
        paginatedBrandtypeRepacks:
            overrides && overrides.hasOwnProperty('paginatedBrandtypeRepacks')
                ? overrides.paginatedBrandtypeRepacks!
                : aPaginatedRepacks(),
        paginatedBrandtypeSamples:
            overrides && overrides.hasOwnProperty('paginatedBrandtypeSamples')
                ? overrides.paginatedBrandtypeSamples!
                : aPaginatedSamples(),
        paginatedDownloadedPacksAndRepacksV2:
            overrides &&
            overrides.hasOwnProperty('paginatedDownloadedPacksAndRepacksV2')
                ? overrides.paginatedDownloadedPacksAndRepacksV2!
                : aPaginatedPacksOrRepacks(),
        paginatedDownloadedSamples:
            overrides && overrides.hasOwnProperty('paginatedDownloadedSamples')
                ? overrides.paginatedDownloadedSamples!
                : aPaginatedSamples(),
        paginatedFavoritedPacksAndRepacksV2:
            overrides &&
            overrides.hasOwnProperty('paginatedFavoritedPacksAndRepacksV2')
                ? overrides.paginatedFavoritedPacksAndRepacksV2!
                : aPaginatedPacksOrRepacks(),
        paginatedFavoritedSamples:
            overrides && overrides.hasOwnProperty('paginatedFavoritedSamples')
                ? overrides.paginatedFavoritedSamples!
                : aPaginatedSamples(),
        paginatedLabelPacks:
            overrides && overrides.hasOwnProperty('paginatedLabelPacks')
                ? overrides.paginatedLabelPacks!
                : aPaginatedPacks(),
        paginatedLabelSamples:
            overrides && overrides.hasOwnProperty('paginatedLabelSamples')
                ? overrides.paginatedLabelSamples!
                : aPaginatedSamples(),
        paginatedLabels:
            overrides && overrides.hasOwnProperty('paginatedLabels')
                ? overrides.paginatedLabels!
                : aPaginatedLabels(),
        paginatedPackSamples:
            overrides && overrides.hasOwnProperty('paginatedPackSamples')
                ? overrides.paginatedPackSamples!
                : aPaginatedSamples(),
        paginatedPacks:
            overrides && overrides.hasOwnProperty('paginatedPacks')
                ? overrides.paginatedPacks!
                : aPaginatedPacks(),
        paginatedPacksAndRepacks:
            overrides && overrides.hasOwnProperty('paginatedPacksAndRepacks')
                ? overrides.paginatedPacksAndRepacks!
                : aPaginatedPacksOrRepacks(),
        paginatedRecommendedSamples:
            overrides && overrides.hasOwnProperty('paginatedRecommendedSamples')
                ? overrides.paginatedRecommendedSamples!
                : aPaginatedSamples(),
        paginatedRepackSamples:
            overrides && overrides.hasOwnProperty('paginatedRepackSamples')
                ? overrides.paginatedRepackSamples!
                : aPaginatedSamples(),
        paginatedRepacks:
            overrides && overrides.hasOwnProperty('paginatedRepacks')
                ? overrides.paginatedRepacks!
                : aPaginatedRepacks(),
        paginatedSamples:
            overrides && overrides.hasOwnProperty('paginatedSamples')
                ? overrides.paginatedSamples!
                : aPaginatedSamples(),
        paginatedUserCollectionSamples:
            overrides &&
            overrides.hasOwnProperty('paginatedUserCollectionSamples')
                ? overrides.paginatedUserCollectionSamples!
                : aPaginatedSamples(),
        paginatedUserCollections:
            overrides && overrides.hasOwnProperty('paginatedUserCollections')
                ? overrides.paginatedUserCollections!
                : aPaginatedUserCollections(),
        pluginPackages:
            overrides && overrides.hasOwnProperty('pluginPackages')
                ? overrides.pluginPackages!
                : aPluginPackages(),
        repack:
            overrides && overrides.hasOwnProperty('repack')
                ? overrides.repack!
                : aRepack(),
        repackCostPreview:
            overrides && overrides.hasOwnProperty('repackCostPreview')
                ? overrides.repackCostPreview!
                : aCostPreviewResponse(),
        repackPurchase:
            overrides && overrides.hasOwnProperty('repackPurchase')
                ? overrides.repackPurchase!
                : aPurchaseResponse(),
        repackStream:
            overrides && overrides.hasOwnProperty('repackStream')
                ? overrides.repackStream!
                : aStreamUrl(),
        sample:
            overrides && overrides.hasOwnProperty('sample')
                ? overrides.sample!
                : aSample(),
        sampleStream:
            overrides && overrides.hasOwnProperty('sampleStream')
                ? overrides.sampleStream!
                : aStreamUrl(),
        sampleWaveform:
            overrides && overrides.hasOwnProperty('sampleWaveform')
                ? overrides.sampleWaveform!
                : aWaveform(),
        samplesCostPreview:
            overrides && overrides.hasOwnProperty('samplesCostPreview')
                ? overrides.samplesCostPreview!
                : aCostPreviewResponse(),
        samplesPurchase:
            overrides && overrides.hasOwnProperty('samplesPurchase')
                ? overrides.samplesPurchase!
                : aPurchaseResponse(),
        seoByPath:
            overrides && overrides.hasOwnProperty('seoByPath')
                ? overrides.seoByPath!
                : aSeo(),
        similarPacks:
            overrides && overrides.hasOwnProperty('similarPacks')
                ? overrides.similarPacks!
                : aPaginatedPacks(),
        subscriptionsAndAllowedFeatures:
            overrides &&
            overrides.hasOwnProperty('subscriptionsAndAllowedFeatures')
                ? overrides.subscriptionsAndAllowedFeatures!
                : aSubscriptionsAndAllowedFeatures(),
        userAgreements:
            overrides && overrides.hasOwnProperty('userAgreements')
                ? overrides.userAgreements!
                : anAgreements(),
        userCollection:
            overrides && overrides.hasOwnProperty('userCollection')
                ? overrides.userCollection!
                : aUserCollection(),
        userCollections:
            overrides && overrides.hasOwnProperty('userCollections')
                ? overrides.userCollections!
                : [aUserCollection()],
        userCollectionsFeed:
            overrides && overrides.hasOwnProperty('userCollectionsFeed')
                ? overrides.userCollectionsFeed!
                : aUserCollectionsFeed(),
        userCredits:
            overrides && overrides.hasOwnProperty('userCredits')
                ? overrides.userCredits!
                : aUserCredits(),
        userProfile:
            overrides && overrides.hasOwnProperty('userProfile')
                ? overrides.userProfile!
                : aUser(),
    };
};

export const aRepack = (
    overrides?: Partial<Repack>,
): { __typename: 'Repack' } & Repack => {
    return {
        __typename: 'Repack',
        artist:
            overrides && overrides.hasOwnProperty('artist')
                ? overrides.artist!
                : anArtist(),
        artworkUrl:
            overrides && overrides.hasOwnProperty('artworkUrl')
                ? overrides.artworkUrl!
                : 'cras',
        backgroundColor:
            overrides && overrides.hasOwnProperty('backgroundColor')
                ? overrides.backgroundColor!
                : 'caries',
        brandtype:
            overrides && overrides.hasOwnProperty('brandtype')
                ? overrides.brandtype!
                : aBrandtype(),
        creatorSession:
            overrides && overrides.hasOwnProperty('creatorSession')
                ? overrides.creatorSession!
                : '5942bbb9-7b2e-4b8f-996e-834c2eb2a9a1',
        description:
            overrides && overrides.hasOwnProperty('description')
                ? overrides.description!
                : 'accusator',
        foregroundColor:
            overrides && overrides.hasOwnProperty('foregroundColor')
                ? overrides.foregroundColor!
                : 'benevolentia',
        genres:
            overrides && overrides.hasOwnProperty('genres')
                ? overrides.genres!
                : [aGenre()],
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : '3a2eca53-dc50-4a01-82c6-1e43f73dd0b1',
        instrument:
            overrides && overrides.hasOwnProperty('instrument')
                ? overrides.instrument!
                : anInstrument(),
        isDownloaded:
            overrides && overrides.hasOwnProperty('isDownloaded')
                ? overrides.isDownloaded!
                : true,
        isExclusive:
            overrides && overrides.hasOwnProperty('isExclusive')
                ? overrides.isExclusive!
                : false,
        isFavorited:
            overrides && overrides.hasOwnProperty('isFavorited')
                ? overrides.isFavorited!
                : true,
        isFree:
            overrides && overrides.hasOwnProperty('isFree')
                ? overrides.isFree!
                : false,
        label:
            overrides && overrides.hasOwnProperty('label')
                ? overrides.label!
                : aLabel(),
        mainGenre:
            overrides && overrides.hasOwnProperty('mainGenre')
                ? overrides.mainGenre!
                : aGenre(),
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'vulariter',
        packState:
            overrides && overrides.hasOwnProperty('packState')
                ? overrides.packState!
                : PackState.Draft,
        premiumCodes:
            overrides && overrides.hasOwnProperty('premiumCodes')
                ? overrides.premiumCodes!
                : [PremiumCodes.LandrStudio],
        sampleCount:
            overrides && overrides.hasOwnProperty('sampleCount')
                ? overrides.sampleCount!
                : 6861,
        sfxs:
            overrides && overrides.hasOwnProperty('sfxs')
                ? overrides.sfxs!
                : [aSfx()],
        slug:
            overrides && overrides.hasOwnProperty('slug')
                ? overrides.slug!
                : 'defendo',
        subType:
            overrides && overrides.hasOwnProperty('subType')
                ? overrides.subType!
                : RepackSubType.Chart,
        type:
            overrides && overrides.hasOwnProperty('type')
                ? overrides.type!
                : PackType.Pack,
    };
};

export const aRepackFavoritedInput = (
    overrides?: Partial<RepackFavoritedInput>,
): RepackFavoritedInput => {
    return {
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : '8da7a2b6-2711-4edd-bb94-572309627a71',
        isFavorited:
            overrides && overrides.hasOwnProperty('isFavorited')
                ? overrides.isFavorited!
                : false,
    };
};

export const aRepacksChart = (
    overrides?: Partial<RepacksChart>,
): { __typename: 'RepacksChart' } & RepacksChart => {
    return {
        __typename: 'RepacksChart',
        items:
            overrides && overrides.hasOwnProperty('items')
                ? overrides.items!
                : [aPacksChartItem()],
    };
};

export const aRepacksChartItem = (
    overrides?: Partial<RepacksChartItem>,
): { __typename: 'RepacksChartItem' } & RepacksChartItem => {
    return {
        __typename: 'RepacksChartItem',
        artistName:
            overrides && overrides.hasOwnProperty('artistName')
                ? overrides.artistName!
                : 'aegre',
        artworkUrl:
            overrides && overrides.hasOwnProperty('artworkUrl')
                ? overrides.artworkUrl!
                : 'absorbeo',
        currentRank:
            overrides && overrides.hasOwnProperty('currentRank')
                ? overrides.currentRank!
                : 6301,
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : '64dc1a78-b54d-4e3d-933f-4f4da72198ee',
        isNew:
            overrides && overrides.hasOwnProperty('isNew')
                ? overrides.isNew!
                : true,
        lastRank:
            overrides && overrides.hasOwnProperty('lastRank')
                ? overrides.lastRank!
                : 4675,
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'odit',
        slug:
            overrides && overrides.hasOwnProperty('slug')
                ? overrides.slug!
                : 'ipsa',
        subItemsCount:
            overrides && overrides.hasOwnProperty('subItemsCount')
                ? overrides.subItemsCount!
                : 5019,
    };
};

export const aSample = (
    overrides?: Partial<Sample>,
): { __typename: 'Sample' } & Sample => {
    return {
        __typename: 'Sample',
        bpm:
            overrides && overrides.hasOwnProperty('bpm')
                ? overrides.bpm!
                : 5551,
        classifiers:
            overrides && overrides.hasOwnProperty('classifiers')
                ? overrides.classifiers!
                : [aClassifier()],
        credits:
            overrides && overrides.hasOwnProperty('credits')
                ? overrides.credits!
                : 7022,
        duration:
            overrides && overrides.hasOwnProperty('duration')
                ? overrides.duration!
                : 3.3,
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : '0595e64f-70b4-4fc1-aa26-f5d69582d993',
        instruments:
            overrides && overrides.hasOwnProperty('instruments')
                ? overrides.instruments!
                : [anInstrument()],
        isDownloaded:
            overrides && overrides.hasOwnProperty('isDownloaded')
                ? overrides.isDownloaded!
                : true,
        isFavorited:
            overrides && overrides.hasOwnProperty('isFavorited')
                ? overrides.isFavorited!
                : false,
        isRecommendationFiller:
            overrides && overrides.hasOwnProperty('isRecommendationFiller')
                ? overrides.isRecommendationFiller!
                : true,
        key:
            overrides && overrides.hasOwnProperty('key')
                ? overrides.key!
                : aSampleKey(),
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'ascisco',
        pack:
            overrides && overrides.hasOwnProperty('pack')
                ? overrides.pack!
                : aPack(),
        sampleState:
            overrides && overrides.hasOwnProperty('sampleState')
                ? overrides.sampleState!
                : SampleState.Available,
        sampleType:
            overrides && overrides.hasOwnProperty('sampleType')
                ? overrides.sampleType!
                : SampleType.Loop,
        sfxs:
            overrides && overrides.hasOwnProperty('sfxs')
                ? overrides.sfxs!
                : [aSfx()],
        tags:
            overrides && overrides.hasOwnProperty('tags')
                ? overrides.tags!
                : [aTag()],
        waveformUrl:
            overrides && overrides.hasOwnProperty('waveformUrl')
                ? overrides.waveformUrl!
                : 'accedo',
    };
};

export const aSampleFavoritedInput = (
    overrides?: Partial<SampleFavoritedInput>,
): SampleFavoritedInput => {
    return {
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : 'f9dda05b-a8c7-4a1e-9ba1-6d7b34ece2e1',
        isFavorited:
            overrides && overrides.hasOwnProperty('isFavorited')
                ? overrides.isFavorited!
                : false,
    };
};

export const aSampleKey = (
    overrides?: Partial<SampleKey>,
): { __typename: 'SampleKey' } & SampleKey => {
    return {
        __typename: 'SampleKey',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'solvo',
        quality:
            overrides && overrides.hasOwnProperty('quality')
                ? overrides.quality!
                : KeyQuality.Major,
        root:
            overrides && overrides.hasOwnProperty('root')
                ? overrides.root!
                : KeyRootApi.A,
        sanitizedCode:
            overrides && overrides.hasOwnProperty('sanitizedCode')
                ? overrides.sanitizedCode!
                : 'sortitus',
    };
};

export const aSampleKeyInput = (
    overrides?: Partial<SampleKeyInput>,
): SampleKeyInput => {
    return {
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'quas',
        quality:
            overrides && overrides.hasOwnProperty('quality')
                ? overrides.quality!
                : KeyQuality.Major,
        root:
            overrides && overrides.hasOwnProperty('root')
                ? overrides.root!
                : KeyRootApi.A,
        sanitizedCode:
            overrides && overrides.hasOwnProperty('sanitizedCode')
                ? overrides.sanitizedCode!
                : 'carmen',
    };
};

export const aSampleTypeFilter = (
    overrides?: Partial<SampleTypeFilter>,
): { __typename: 'SampleTypeFilter' } & SampleTypeFilter => {
    return {
        __typename: 'SampleTypeFilter',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'carcer',
    };
};

export const aSamplesIncludedFeature = (
    overrides?: Partial<SamplesIncludedFeature>,
): { __typename: 'SamplesIncludedFeature' } & SamplesIncludedFeature => {
    return {
        __typename: 'SamplesIncludedFeature',
        hasPaidContentAccess:
            overrides && overrides.hasOwnProperty('hasPaidContentAccess')
                ? overrides.hasPaidContentAccess!
                : false,
        hasSamplesCredits:
            overrides && overrides.hasOwnProperty('hasSamplesCredits')
                ? overrides.hasSamplesCredits!
                : true,
        includedCredits:
            overrides && overrides.hasOwnProperty('includedCredits')
                ? overrides.includedCredits!
                : [aGrantedCredits()],
    };
};

export const aSeo = (overrides?: Partial<Seo>): { __typename: 'Seo' } & Seo => {
    return {
        __typename: 'Seo',
        byline:
            overrides && overrides.hasOwnProperty('byline')
                ? overrides.byline!
                : 'consequatur',
        description:
            overrides && overrides.hasOwnProperty('description')
                ? overrides.description!
                : 'denego',
        header:
            overrides && overrides.hasOwnProperty('header')
                ? overrides.header!
                : 'victus',
        title:
            overrides && overrides.hasOwnProperty('title')
                ? overrides.title!
                : 'crepusculum',
        url:
            overrides && overrides.hasOwnProperty('url')
                ? overrides.url!
                : 'ab',
    };
};

export const aSeoMetadata = (
    overrides?: Partial<SeoMetadata>,
): { __typename: 'SeoMetadata' } & SeoMetadata => {
    return {
        __typename: 'SeoMetadata',
        description:
            overrides && overrides.hasOwnProperty('description')
                ? overrides.description!
                : 'virga',
        title:
            overrides && overrides.hasOwnProperty('title')
                ? overrides.title!
                : 'cattus',
    };
};

export const aSeoMetadataInput = (
    overrides?: Partial<SeoMetadataInput>,
): SeoMetadataInput => {
    return {
        description:
            overrides && overrides.hasOwnProperty('description')
                ? overrides.description!
                : 'traho',
        title:
            overrides && overrides.hasOwnProperty('title')
                ? overrides.title!
                : 'eligendi',
    };
};

export const aSfx = (overrides?: Partial<Sfx>): { __typename: 'Sfx' } & Sfx => {
    return {
        __typename: 'Sfx',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'abutor',
        subSfxs:
            overrides && overrides.hasOwnProperty('subSfxs')
                ? overrides.subSfxs!
                : [aSubItems()],
    };
};

export const aStreamUrl = (
    overrides?: Partial<StreamUrl>,
): { __typename: 'StreamUrl' } & StreamUrl => {
    return {
        __typename: 'StreamUrl',
        url:
            overrides && overrides.hasOwnProperty('url')
                ? overrides.url!
                : 'trado',
    };
};

export const aSubItems = (
    overrides?: Partial<SubItems>,
): { __typename: 'SubItems' } & SubItems => {
    return {
        __typename: 'SubItems',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'cernuus',
    };
};

export const aSubscriptionCreditsDetails = (
    overrides?: Partial<SubscriptionCreditsDetails>,
): {
    __typename: 'SubscriptionCreditsDetails';
} & SubscriptionCreditsDetails => {
    return {
        __typename: 'SubscriptionCreditsDetails',
        expirationDate:
            overrides && overrides.hasOwnProperty('expirationDate')
                ? overrides.expirationDate!
                : '2021-07-04T15:38:52.188Z',
        serviceOffer:
            overrides && overrides.hasOwnProperty('serviceOffer')
                ? overrides.serviceOffer!
                : ServiceOfferKind.Bundles,
    };
};

export const aSubscriptionDetails = (
    overrides?: Partial<SubscriptionDetails>,
): { __typename: 'SubscriptionDetails' } & SubscriptionDetails => {
    return {
        __typename: 'SubscriptionDetails',
        current:
            overrides && overrides.hasOwnProperty('current')
                ? overrides.current!
                : aCurrentSubscriptionDetails(),
        isTrial:
            overrides && overrides.hasOwnProperty('isTrial')
                ? overrides.isTrial!
                : false,
        isTrialingSubscription:
            overrides && overrides.hasOwnProperty('isTrialingSubscription')
                ? overrides.isTrialingSubscription!
                : true,
        isYearly:
            overrides && overrides.hasOwnProperty('isYearly')
                ? overrides.isYearly!
                : false,
        serviceOffer:
            overrides && overrides.hasOwnProperty('serviceOffer')
                ? overrides.serviceOffer!
                : ServiceOfferKind.Bundles,
        status:
            overrides && overrides.hasOwnProperty('status')
                ? overrides.status!
                : SubscriptionDetailsStatus.Cancelling,
        subscriptionCreditsDetails:
            overrides && overrides.hasOwnProperty('subscriptionCreditsDetails')
                ? overrides.subscriptionCreditsDetails!
                : [aSubscriptionCreditsDetails()],
    };
};

export const aSubscriptionPlanProductDetails = (
    overrides?: Partial<SubscriptionPlanProductDetails>,
): {
    __typename: 'SubscriptionPlanProductDetails';
} & SubscriptionPlanProductDetails => {
    return {
        __typename: 'SubscriptionPlanProductDetails',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'alienus',
        currentQuantity:
            overrides && overrides.hasOwnProperty('currentQuantity')
                ? overrides.currentQuantity!
                : 6.4,
        endDate:
            overrides && overrides.hasOwnProperty('endDate')
                ? overrides.endDate!
                : 'creta',
        isUnlimited:
            overrides && overrides.hasOwnProperty('isUnlimited')
                ? overrides.isUnlimited!
                : false,
        maxQuantity:
            overrides && overrides.hasOwnProperty('maxQuantity')
                ? overrides.maxQuantity!
                : 2.8,
        numberOfCredits:
            overrides && overrides.hasOwnProperty('numberOfCredits')
                ? overrides.numberOfCredits!
                : 1347,
        status:
            overrides && overrides.hasOwnProperty('status')
                ? overrides.status!
                : SubscriptionProductStatus.Active,
    };
};

export const aSubscriptionsAndAllowedFeatures = (
    overrides?: Partial<SubscriptionsAndAllowedFeatures>,
): {
    __typename: 'SubscriptionsAndAllowedFeatures';
} & SubscriptionsAndAllowedFeatures => {
    return {
        __typename: 'SubscriptionsAndAllowedFeatures',
        hasSamplesPlan:
            overrides && overrides.hasOwnProperty('hasSamplesPlan')
                ? overrides.hasSamplesPlan!
                : true,
        hasStudioPlan:
            overrides && overrides.hasOwnProperty('hasStudioPlan')
                ? overrides.hasStudioPlan!
                : false,
        hasSubscription:
            overrides && overrides.hasOwnProperty('hasSubscription')
                ? overrides.hasSubscription!
                : false,
        samplePaidContentAccess:
            overrides && overrides.hasOwnProperty('samplePaidContentAccess')
                ? overrides.samplePaidContentAccess!
                : anAllowedFeature(),
        subscriptionsDetails:
            overrides && overrides.hasOwnProperty('subscriptionsDetails')
                ? overrides.subscriptionsDetails!
                : [aSubscriptionDetails()],
        upsellingAllowed:
            overrides && overrides.hasOwnProperty('upsellingAllowed')
                ? overrides.upsellingAllowed!
                : true,
    };
};

export const aTag = (overrides?: Partial<Tag>): { __typename: 'Tag' } & Tag => {
    return {
        __typename: 'Tag',
        category:
            overrides && overrides.hasOwnProperty('category')
                ? overrides.category!
                : 'apto',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'mollitia',
        displayName:
            overrides && overrides.hasOwnProperty('displayName')
                ? overrides.displayName!
                : 'vacuus',
    };
};

export const aTagCategoryFilter = (
    overrides?: Partial<TagCategoryFilter>,
): { __typename: 'TagCategoryFilter' } & TagCategoryFilter => {
    return {
        __typename: 'TagCategoryFilter',
        code:
            overrides && overrides.hasOwnProperty('code')
                ? overrides.code!
                : 'velum',
        label:
            overrides && overrides.hasOwnProperty('label')
                ? overrides.label!
                : 'fugiat',
    };
};

export const aTagsCategory = (
    overrides?: Partial<TagsCategory>,
): { __typename: 'TagsCategory' } & TagsCategory => {
    return {
        __typename: 'TagsCategory',
        category:
            overrides && overrides.hasOwnProperty('category')
                ? overrides.category!
                : 'porro',
        list:
            overrides && overrides.hasOwnProperty('list')
                ? overrides.list!
                : [aTagCategoryFilter()],
    };
};

export const aTrack = (
    overrides?: Partial<Track>,
): { __typename: 'Track' } & Track => {
    return {
        __typename: 'Track',
        bpm:
            overrides && overrides.hasOwnProperty('bpm') ? overrides.bpm! : 833,
        bpmMultiplier:
            overrides && overrides.hasOwnProperty('bpmMultiplier')
                ? overrides.bpmMultiplier!
                : BpmMultiplier.Double,
        gain:
            overrides && overrides.hasOwnProperty('gain')
                ? overrides.gain!
                : 3988,
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : '18a6f787-71c1-4150-8db4-b84a122151ac',
        pitchTranspose:
            overrides && overrides.hasOwnProperty('pitchTranspose')
                ? overrides.pitchTranspose!
                : 2910,
    };
};

export const aTrackInput = (overrides?: Partial<TrackInput>): TrackInput => {
    return {
        bpm:
            overrides && overrides.hasOwnProperty('bpm')
                ? overrides.bpm!
                : 8766,
        bpmMultiplier:
            overrides && overrides.hasOwnProperty('bpmMultiplier')
                ? overrides.bpmMultiplier!
                : BpmMultiplier.Double,
        gain:
            overrides && overrides.hasOwnProperty('gain')
                ? overrides.gain!
                : 4035,
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : 'f915eb64-0423-4103-9010-e67225730857',
        pitchTranspose:
            overrides && overrides.hasOwnProperty('pitchTranspose')
                ? overrides.pitchTranspose!
                : 7898,
    };
};

export const anUnallowedReason = (
    overrides?: Partial<UnallowedReason>,
): { __typename: 'UnallowedReason' } & UnallowedReason => {
    return {
        __typename: 'UnallowedReason',
        reason:
            overrides && overrides.hasOwnProperty('reason')
                ? overrides.reason!
                : 'velit',
        unallowedByPlan:
            overrides && overrides.hasOwnProperty('unallowedByPlan')
                ? overrides.unallowedByPlan!
                : 'auditor',
    };
};

export const aUser = (
    overrides?: Partial<User>,
): { __typename: 'User' } & User => {
    return {
        __typename: 'User',
        country:
            overrides && overrides.hasOwnProperty('country')
                ? overrides.country!
                : 'ars',
        creationTime:
            overrides && overrides.hasOwnProperty('creationTime')
                ? overrides.creationTime!
                : 'nihil',
        displayName:
            overrides && overrides.hasOwnProperty('displayName')
                ? overrides.displayName!
                : 'depulso',
        email:
            overrides && overrides.hasOwnProperty('email')
                ? overrides.email!
                : 'natus',
        experience:
            overrides && overrides.hasOwnProperty('experience')
                ? overrides.experience!
                : 'tui',
        firstname:
            overrides && overrides.hasOwnProperty('firstname')
                ? overrides.firstname!
                : 'ambitus',
        hasSeenArchiveNotification:
            overrides && overrides.hasOwnProperty('hasSeenArchiveNotification')
                ? overrides.hasSeenArchiveNotification!
                : false,
        homePage:
            overrides && overrides.hasOwnProperty('homePage')
                ? overrides.homePage!
                : HomePageEnum.Chromatic,
        isArchived:
            overrides && overrides.hasOwnProperty('isArchived')
                ? overrides.isArchived!
                : true,
        lastname:
            overrides && overrides.hasOwnProperty('lastname')
                ? overrides.lastname!
                : 'collum',
        musicGenres:
            overrides && overrides.hasOwnProperty('musicGenres')
                ? overrides.musicGenres!
                : [MusicGenre.Acoustic],
        permalink:
            overrides && overrides.hasOwnProperty('permalink')
                ? overrides.permalink!
                : 'canis',
        preferredCulture:
            overrides && overrides.hasOwnProperty('preferredCulture')
                ? overrides.preferredCulture!
                : 'atrocitas',
        primaryOccupation:
            overrides && overrides.hasOwnProperty('primaryOccupation')
                ? overrides.primaryOccupation!
                : OccupationEnum.AR,
        profilePicture72Url:
            overrides && overrides.hasOwnProperty('profilePicture72Url')
                ? overrides.profilePicture72Url!
                : 'acquiro',
        profilePicture360Url:
            overrides && overrides.hasOwnProperty('profilePicture360Url')
                ? overrides.profilePicture360Url!
                : 'curso',
        secondaryOccupations:
            overrides && overrides.hasOwnProperty('secondaryOccupations')
                ? overrides.secondaryOccupations!
                : [OccupationEnum.AR],
        signupCountry:
            overrides && overrides.hasOwnProperty('signupCountry')
                ? overrides.signupCountry!
                : 'atqui',
        signupCountryCode:
            overrides && overrides.hasOwnProperty('signupCountryCode')
                ? overrides.signupCountryCode!
                : 'campana',
        signupState:
            overrides && overrides.hasOwnProperty('signupState')
                ? overrides.signupState!
                : 'bonus',
        userId:
            overrides && overrides.hasOwnProperty('userId')
                ? overrides.userId!
                : 'sub',
    };
};

export const aUserCollection = (
    overrides?: Partial<UserCollection>,
): { __typename: 'UserCollection' } & UserCollection => {
    return {
        __typename: 'UserCollection',
        artworkUrl:
            overrides && overrides.hasOwnProperty('artworkUrl')
                ? overrides.artworkUrl!
                : 'cado',
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : 'f94b11e3-8607-4a98-9fac-0a55965d0839',
        name:
            overrides && overrides.hasOwnProperty('name')
                ? overrides.name!
                : 'dedico',
        sampleCount:
            overrides && overrides.hasOwnProperty('sampleCount')
                ? overrides.sampleCount!
                : 7281,
        slug:
            overrides && overrides.hasOwnProperty('slug')
                ? overrides.slug!
                : 'crastinus',
        userId:
            overrides && overrides.hasOwnProperty('userId')
                ? overrides.userId!
                : 'daa99abc-88f1-4e4f-a9c0-33e7c48780c5',
    };
};

export const aUserCollectionsFeed = (
    overrides?: Partial<UserCollectionsFeed>,
): { __typename: 'UserCollectionsFeed' } & UserCollectionsFeed => {
    return {
        __typename: 'UserCollectionsFeed',
        feed:
            overrides && overrides.hasOwnProperty('feed')
                ? overrides.feed!
                : [aUserCollection()],
        meta:
            overrides && overrides.hasOwnProperty('meta')
                ? overrides.meta!
                : aMetaPage(),
    };
};

export const aUserCredits = (
    overrides?: Partial<UserCredits>,
): { __typename: 'UserCredits' } & UserCredits => {
    return {
        __typename: 'UserCredits',
        remaining:
            overrides && overrides.hasOwnProperty('remaining')
                ? overrides.remaining!
                : 9894,
    };
};

export const aUserRecentSearch = (
    overrides?: Partial<UserRecentSearch>,
): { __typename: 'UserRecentSearch' } & UserRecentSearch => {
    return {
        __typename: 'UserRecentSearch',
        filterSlug:
            overrides && overrides.hasOwnProperty('filterSlug')
                ? overrides.filterSlug!
                : 'pecto',
        searchFilter:
            overrides && overrides.hasOwnProperty('searchFilter')
                ? overrides.searchFilter!
                : UserSearchFilter.Descriptors,
    };
};

export const aUserRecentSearches = (
    overrides?: Partial<UserRecentSearches>,
): { __typename: 'UserRecentSearches' } & UserRecentSearches => {
    return {
        __typename: 'UserRecentSearches',
        recentSearch:
            overrides && overrides.hasOwnProperty('recentSearch')
                ? overrides.recentSearch!
                : [aUserRecentSearch()],
    };
};

export const aWaveform = (
    overrides?: Partial<Waveform>,
): { __typename: 'Waveform' } & Waveform => {
    return {
        __typename: 'Waveform',
        guid:
            overrides && overrides.hasOwnProperty('guid')
                ? overrides.guid!
                : 'ad98576b-a1b5-4f1b-a932-1b82226e71a0',
        waveform:
            overrides && overrides.hasOwnProperty('waveform')
                ? overrides.waveform!
                : [1.5],
    };
};
